export default {
      id: "arrow-up-circle-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#arrow-up-circle",
      toString: function () {
        return this.url;
      }
    }